import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import FeatureGrid from './components/FeatureGrid';
import ArticlePreview from './components/ArticlePreview';
import ComparisonSection from './components/ComparisonSection';
import TrustSection from './components/TrustSection';
import FinalCTA from './components/FinalCTA';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://sugargoospreadsheet.icu';

const homepageSEO = {
  title: 'Sugargoo Spreadsheet Guide 2026 | Best Updated Lists & Shopping Tutorials',
  description: 'Discover the latest Sugargoo Spreadsheet guides, sneaker lists, and fashion finds. Learn how to use spreadsheets, compare agents, and explore updated shopping resources for 2026.',
  keywords: 'sugargoo spreadsheet, sugargoo spreadsheet guide, sugargoo shopping, spreadsheet lists 2026, sneaker spreadsheet',
  canonicalUrl: `${SITE_URL}/`,
  ogTitle: 'Sugargoo Spreadsheet Guide 2026 | Best Updated Lists & Shopping Tutorials',
  ogDescription: 'Discover the latest Sugargoo Spreadsheet guides, sneaker lists, and fashion finds. Updated regularly for 2026.',
  ogType: 'website' as const,
  ogUrl: `${SITE_URL}/`,
  jsonLd: {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: 'Sugargoo Spreadsheet Guide',
        url: SITE_URL,
        description: 'Find the latest Sugargoo spreadsheet links, sneaker lists, streetwear finds, and shopping guides — updated regularly.',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${SITE_URL}/?search={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: 'Sugargoo Spreadsheet Guide',
        url: SITE_URL,
        description: 'We provide curated Sugargoo spreadsheet guides, product category links, and shopping tutorials to help shoppers discover items faster.',
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What is Sugargoo Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'A Sugargoo spreadsheet is a curated collection of product links organized into categories that helps shoppers find items on the Sugargoo platform faster than manual search.',
            },
          },
          {
            '@type': 'Question',
            name: 'How do I use a Sugargoo spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Choose a category, browse the curated links, click any product that interests you to view it on Sugargoo, add to your cart, and proceed through the standard checkout process.',
            },
          },
          {
            '@type': 'Question',
            name: 'Is Sugargoo safe to use?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sugargoo acts as an intermediary between buyers and sellers, handling payment processing, quality inspection, and dispute resolution. While shopping always carries some risk, Sugargoo provides buyer protection for most transactions.',
            },
          },
        ],
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead {...homepageSEO} />
      <Header />
      <main>
        <HeroSection />
        <WhatIsSection />
        <CategorySection />
        <FeatureGrid />
        <ArticlePreview />
        <ComparisonSection />
        <TrustSection />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}